import React, { Component } from 'react';
// import Cookie from 'js-cookie';
import { injectIntl } from 'react-intl';
import { Button } from 'react-materialize';

import Logger from '../../functions/logging';

// const propTypes = {
// 	locale: PropTypes.string.isRequired,
// };

import * as localeFns from '../../functions/locale';

class LocaleButton extends Component {
	constructor() {
		super();

		this.handleClick = this.handleClick.bind(this);
	}

	handleClick() {
		const locale = this.props.intl && this.props.intl.locale ? this.props.intl.locale : "en";
		localeFns.setLocale(locale === 'en' ? 'es' : 'en');
		window.location.reload();
	}

	render() {
		Logger.log(this.constructor.name, this.props);

		const locale = this.props.intl && this.props.intl.locale ? this.props.intl.locale : "en";

		return <Button className="pilotly-locale" onClick={this.handleClick}>{locale === 'en' ? 'Spanish' : 'English'}</Button>;
	}
}
	
// LocaleButton.propTypes = propTypes;
	
export default injectIntl(LocaleButton);



// WEBPACK FOOTER //
// ./src/components/global/LocaleButton.js